import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let moduleEl = this.el
        
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    moduleEl.classList.add('is-show')
                } else {
                    moduleEl.classList.remove('is-show')
                }
            })
        })

        this.observer.observe(moduleEl)
    }

    destroy() {
        super.destroy()
    }
}